import {
  Banknote,
  CalendarDays,
  CheckCircleIcon,
  ChevronDown,
  ChevronLeft,
  MapPin,
  MessageSquareText,
} from "lucide-react";
import { useState } from "react";
import CurrentStatus from "./components/CurrentStatus";
import SkillsTable from "./components/SkillsTable";
import { ProgressCircle } from "./components/ProgressCircle";

const tabs = [
  {
    label: "Overview",
    value: "overview",
  },
  {
    label: "Tracker",
    value: "tracker",
  },
  {
    label: "Messages",
    value: "messages",
  },
  {
    label: "Job Details",
    value: "job-details",
  },
  {
    label: "Skills & Experience",
    value: "skills-and-experience",
  },
];

const additionalRequirements = [
  "Strong understanding of responsive design and cross-browser compatibility.",
  "Experience with CI/CD pipelines and automated testing.",
  "Excellent problem-solving skills and attention to detail.",
];

const AppliedJobDetailsNew = () => {
  const [activeTab, setActiveTab] = useState("skills-and-experience");

  return (
    <div className="flex flex-col flex-1 min-w-0 rounded-md bg-white p-4 gap-3 min-h-0 overflow-y-scroll no-scrollbar">
      <button className="flex items-center font-semibold text-xs text-charcoal">
        <ChevronLeft size={16} />
        Back to Applied Jobs
      </button>

      {/* Top header */}
      <div className="flex items-center rounded-md border px-4 pt-4">
        <div className="flex flex-col gap-6">
          <div className="flex gap-5">
            <div className="flex justify-center items-center bg-charcoal h-14 w-14 rounded-md">
              <span className="text-white font-bold text-4xl">A</span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="font-semibold">Mid Level React Developer</span>
              <span className="font-semibold text-xs">Cybersecure Ltd</span>
              <div className="flex items-center text-primary text-xss font-semibold gap-5">
                <div className="flex items-center gap-1.5">
                  <MapPin size={14} />
                  <span>London, UK</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <CalendarDays size={14} />
                  <span>Full Time</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Banknote size={14} />
                  <span>60,000 - 80,000</span>
                </div>
              </div>
            </div>
          </div>
          {/* Tabs container */}
          <div className="flex gap-12">
            {tabs?.map((tab) => {
              const isActive = tab?.value === activeTab;
              return (
                <button
                  onClick={() => setActiveTab(tab?.value)}
                  className={`flex flex-col font-semibold text-xs text-primary gap-2.5 `}
                >
                  {tab?.label}
                  <div
                    className={`h-[3px] w-full rounded-t ${isActive ? "bg-primary" : "bg-transparent"}`}
                  ></div>
                </button>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>

      {/* Main container */}
      <div className="flex flex-1 gap-3">
        {/* Column 1 */}
        <div className="flex flex-col flex-1 min-w-0 border rounded-md p-3 gap-3">
          {/* Header */}
          <div className="flex items-center justify-between gap-10">
            <div className="flex flex-col gap-1">
              <span className="font-bold text-sm">
                Required Skills & Experience
              </span>
              <span className="font-semibold text-xss text-blue-900">
                The key skills and experience required for this role. Review the
                details below to ensure you meet the requirements.
              </span>
            </div>
            <div className="flex items-center shrink-0 gap-3">
              <span className="font-semibold text-xss">Overall Match</span>
              <ProgressCircle strokeWidth={2} percentage={78} size={50} />
            </div>
          </div>

          <SkillsTable />

          {/* Additional Experience */}
          <div className="flex flex-col gap-2 rounded-md bg-light-white-900 p-3 border">
            <div className="flex items-center justify-between">
              <span className="font-bold text-xs">
                Additional Experience Requirements (3)
              </span>
              <ChevronDown size={15} />
            </div>
            <div className="flex flex-col gap-2">
              {
                additionalRequirements?.map((requirement)=>{
                  return<div className="flex items-center gap-2">
                    <CheckCircleIcon size={12} color="green"/>
                    <span className="text-xsss text-blue-700 font-semibold">{requirement}</span>
                  </div>
                })
              }
            </div>
          </div>
        </div>
        {/* Column 2 */}
        <div className="flex flex-col w-[28%] gap-3">
          {/* Current status section*/}
          <CurrentStatus />
          {/* Need help section */}
          <div className="flex items-center border bg-light-white-900 rounded-md p-3">
            <div className="flex flex-col gap-3">
              <span className="text-xss font-bold">Need help?</span>
              <span className="text-xsss font-semibold text-blue-900">
                If you have any question regarding your application, please
                contact the recruiter.
              </span>
              <button className="text-xss font-semibold rounded-md bg-white border w-max px-3 py-2">
                Contact Recruiter
              </button>
            </div>
            <div className="h-8 w-8 rounded-full flex items-center justify-center bg-gray-200 shrink-0">
              <MessageSquareText size={16} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedJobDetailsNew;
